import { render, staticRenderFns } from "./AdminSupportNavDrawer.vue?vue&type=template&id=5b13004c&"
import script from "./AdminSupportNavDrawer.vue?vue&type=script&lang=js&"
export * from "./AdminSupportNavDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports